/**
 * Engraving: multi-type config (Engraving Config metaobject), fees, optional logo file + waiver,
 * second side. Intercepts product form submit when engraving applied.
 */
(function () {
  var DEFAULT_CHAR_LIMIT = 12;
  var MAX_LOGO_BYTES = 20 * 1024 * 1024; // Shopify upload limit

  function getConfig(sectionId) {
    var el = document.getElementById('engraving-config-' + sectionId);
    if (!el || !el.textContent) return null;
    try {
      return JSON.parse(el.textContent);
    } catch (_) {
      return null;
    }
  }

  function getTypeByKey(config, key) {
    var types = config.engravingTypes || [];
    var k = key != null ? String(key) : '';
    for (var i = 0; i < types.length; i++) {
      if (String(types[i].key) === k) return types[i];
    }
    return types[0] || null;
  }

  function getSelectedTypeKey(wrapper, config) {
    var sel = wrapper.querySelector('.engraving-type-option.selected');
    if (sel && sel.dataset.engravingTypeKey) return sel.dataset.engravingTypeKey;
    return config.defaultTypeKey || (config.engravingTypes[0] && config.engravingTypes[0].key) || 'default';
  }

  /** Quantity lives outside &lt;form&gt; but is tied via form="…"; form.elements includes it, querySelector does not. */
  function getFormQuantityInput(form) {
    if (!form || !form.elements) return null;
    var el = form.elements.namedItem('quantity');
    if (!el) return form.querySelector('input[name="quantity"]');
    if (el.tagName === 'INPUT') return el;
    if (typeof el.length === 'number' && el[0]) return el[0];
    return null;
  }

  function getFormQuantity(form) {
    var input = getFormQuantityInput(form);
    if (!input) return 1;
    var v = parseInt(String(input.value).trim(), 10);
    if (isNaN(v) || v < 1) return 1;
    return v;
  }

  function setFormQuantity(form, qty) {
    var input = getFormQuantityInput(form);
    if (!input) return;
    var n = Math.max(1, parseInt(qty, 10) || 1);
    input.value = String(n);
    input.dispatchEvent(new Event('input', { bubbles: true }));
    input.dispatchEvent(new Event('change', { bubbles: true }));
  }

  function getLines(wrapper, maxLines) {
    var lines = [];
    for (var i = 1; i <= maxLines; i++) {
      var input = wrapper.querySelector('[data-engraving-line="' + i + '"]');
      if (input) lines.push((input.value || '').trim());
    }
    return lines;
  }

  function getSide2Lines(wrapper, maxLines) {
    var lines = [];
    for (var i = 1; i <= maxLines; i++) {
      var input = wrapper.querySelector('[data-engraving-side2-line="' + i + '"]');
      if (input) lines.push((input.value || '').trim());
    }
    return lines;
  }

  function getSelectedFont(wrapper) {
    var btn = wrapper.querySelector('.engraving-font-option.selected');
    if (!btn) return { label: 'Sans', value: 'sans', cssFontFamily: 'inherit' };
    return {
      label: btn.dataset.fontLabel || 'Sans',
      value: btn.dataset.fontValue || 'sans',
      cssFontFamily: btn.dataset.fontCss || 'inherit'
    };
  }

  function rebuildFontOptions(wrapper, fonts) {
    var container = wrapper.querySelector('[data-engraving-fonts]');
    if (!container) return;
    container.innerHTML = '';
    var list = fonts && fonts.length ? fonts : [
      { label: 'Handwriting', value: 'handwriting', cssFontFamily: 'inherit' },
      { label: 'Sans', value: 'sans', cssFontFamily: 'inherit' }
    ];
    list.forEach(function (f, idx) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'engraving-font-option' + (idx === 0 ? ' selected' : '');
      b.dataset.fontValue = f.value || '';
      b.dataset.fontLabel = f.label || '';
      b.dataset.fontCss = f.cssFontFamily || 'inherit';
      var sample = document.createElement('span');
      sample.className = 'engraving-font-sample';
      sample.style.fontFamily = f.cssFontFamily && f.cssFontFamily !== 'inherit' ? f.cssFontFamily : 'inherit';
      sample.textContent = 'Aa';
      var lbl = document.createElement('span');
      lbl.textContent = f.label || '';
      b.appendChild(sample);
      b.appendChild(lbl);
      b.addEventListener('click', function () {
        container.querySelectorAll('.engraving-font-option').forEach(function (x) { x.classList.remove('selected'); });
        b.classList.add('selected');
        var sid = wrapper.getAttribute('data-engraving-section');
        var cfg = getConfig(sid);
        var tk = getSelectedTypeKey(wrapper, cfg);
        var tc = getTypeByKey(cfg, tk);
        if (tc) updatePreview(wrapper, tc);
      });
      container.appendChild(b);
    });
  }

  function updateMinQtyHint(wrapper, typeConfig) {
    var el = wrapper.querySelector('[data-engraving-min-qty-msg]');
    if (!el || !typeConfig) return;
    var n = typeConfig.minQuantity || 1;
    el.textContent = n > 1 ? 'Minimum quantity for this engraving: ' + n + ' units.' : '';
  }

  function applyTypeToUI(wrapper, config, typeConfig) {
    if (!typeConfig) return;
    var ml = Math.min(Math.max(typeConfig.maxLines || 3, 1), 3);
    var limit = typeConfig.characterLimitPerLine || DEFAULT_CHAR_LIMIT;
    wrapper.querySelectorAll('.engraving-input[data-engraving-line]').forEach(function (inp) {
      inp.setAttribute('maxlength', limit);
    });
    var row2 = wrapper.querySelector('[data-engraving-row-2]');
    var row3 = wrapper.querySelector('[data-engraving-row-3]');
    if (row2) row2.hidden = ml < 2;
    if (row3) row3.hidden = ml < 3;

    wrapper.querySelectorAll('.engraving-input[data-engraving-side2-line]').forEach(function (inp) {
      inp.setAttribute('maxlength', limit);
    });
    var s2r2 = wrapper.querySelector('[data-engraving-side2-row-2]');
    var s2r3 = wrapper.querySelector('[data-engraving-side2-row-3]');
    if (s2r2) s2r2.hidden = ml < 2 || !typeConfig.allowSecondSide;
    if (s2r3) s2r3.hidden = ml < 3 || !typeConfig.allowSecondSide;

    var logoG = wrapper.querySelector('[data-engraving-logo-group]');
    if (logoG) logoG.hidden = !typeConfig.allowLogoUpload;
    var optIn = wrapper.querySelector('[data-engraving-side2-opt-in]');
    if (optIn) optIn.hidden = !typeConfig.allowSecondSide;
    var side2cb = wrapper.querySelector('[data-engraving-side2-checkbox]');
    if (side2cb) side2cb.checked = false;
    var side2b = wrapper.querySelector('[data-engraving-side2-block]');
    if (side2b) side2b.hidden = true;
    var prevS2 = wrapper.querySelector('[data-engraving-preview-side2]');
    if (prevS2) prevS2.hidden = true;

    rebuildFontOptions(wrapper, typeConfig.fonts);
    updateMinQtyHint(wrapper, typeConfig);
    updateCharCountsForType(wrapper, typeConfig);
    updatePreview(wrapper, typeConfig);
  }

  function updateCharCountsForType(wrapper, typeConfig) {
    var limit = typeConfig.characterLimitPerLine || DEFAULT_CHAR_LIMIT;
    wrapper.querySelectorAll('.engraving-input[data-engraving-line]').forEach(function (input) {
      var n = input.dataset.engravingLine;
      var countEl = wrapper.querySelector('[data-char-count="' + n + '"]');
      if (countEl) countEl.textContent = (input.value || '').length + '/' + limit;
    });
    wrapper.querySelectorAll('.engraving-input[data-engraving-side2-line]').forEach(function (input) {
      var n = input.dataset.engravingSide2Line;
      var countEl = wrapper.querySelector('[data-char-count-side2="' + n + '"]');
      if (countEl) countEl.textContent = (input.value || '').length + '/' + limit;
    });
  }

  function updatePreview(wrapper, typeConfig) {
    var ml = Math.min(Math.max(typeConfig.maxLines || 3, 1), 3);
    var lines = getLines(wrapper, ml);
    var font = getSelectedFont(wrapper);
    var plate = wrapper.querySelector('[data-engraving-preview]');
    var style = font.cssFontFamily && font.cssFontFamily !== 'inherit'
      ? 'font-family: ' + font.cssFontFamily
      : '';
    if (plate) {
      for (var i = 1; i <= 3; i++) {
        var lineEl = plate.querySelector('[data-preview-line="' + i + '"]');
        if (lineEl) {
          lineEl.textContent = lines[i - 1] || '';
          lineEl.style.cssText = style;
        }
      }
    }
    if (typeConfig.allowSecondSide) {
      var s2 = getSide2Lines(wrapper, ml);
      for (var j = 1; j <= 3; j++) {
        var el2 = wrapper.querySelector('[data-preview-side2-line="' + j + '"]');
        if (el2) {
          el2.textContent = s2[j - 1] || '';
          el2.style.cssText = style;
        }
      }
    }
  }

  function setOrRemoveHiddenInputs(form, payload) {
    var container = form.querySelector('.engraving-hidden-inputs') || (function () {
      var div = document.createElement('div');
      div.className = 'engraving-hidden-inputs';
      div.setAttribute('aria-hidden', 'true');
      form.appendChild(div);
      return div;
    })();
    container.innerHTML = '';
    if (!payload || !payload.engraving_enabled) return;
    var props = [
      { name: '_engraving', value: 'Yes' },
      { name: '_engraving_id', value: payload.engraving_id },
      { name: '_engraving_type_key', value: payload.type_key || '' },
      { name: '_engraving_font', value: payload.font_label },
      { name: '_engraving_line_1', value: (payload.lines && payload.lines[0]) || '' },
      { name: '_engraving_line_2', value: (payload.lines && payload.lines[1]) || '' },
      { name: '_engraving_line_3', value: (payload.lines && payload.lines[2]) || '' },
      { name: '_engraving_side2_1', value: (payload.side2_lines && payload.side2_lines[0]) || '' },
      { name: '_engraving_side2_2', value: (payload.side2_lines && payload.side2_lines[1]) || '' },
      { name: '_engraving_side2_3', value: (payload.side2_lines && payload.side2_lines[2]) || '' },
      { name: '_engraving_logo_waiver', value: payload.logo_waiver ? 'Yes' : 'No' }
    ];
    props.forEach(function (p) {
      var input = document.createElement('input');
      input.type = 'hidden';
      input.name = p.name;
      input.value = p.value;
      container.appendChild(input);
    });
  }

  function getEngravingPayloadFromForm(form) {
    var container = form.querySelector('.engraving-hidden-inputs');
    if (!container) return null;
    var idInput = container.querySelector('input[name="_engraving_id"]');
    if (!idInput || !idInput.value) return null;
    return {
      engraving_id: idInput.value,
      type_key: (container.querySelector('input[name="_engraving_type_key"]') || {}).value,
      font_label: (container.querySelector('input[name="_engraving_font"]') || {}).value,
      lines: [
        (container.querySelector('input[name="_engraving_line_1"]') || {}).value,
        (container.querySelector('input[name="_engraving_line_2"]') || {}).value,
        (container.querySelector('input[name="_engraving_line_3"]') || {}).value
      ],
      side2_lines: [
        (container.querySelector('input[name="_engraving_side2_1"]') || {}).value,
        (container.querySelector('input[name="_engraving_side2_2"]') || {}).value,
        (container.querySelector('input[name="_engraving_side2_3"]') || {}).value
      ],
      logo_waiver: ((container.querySelector('input[name="_engraving_logo_waiver"]') || {}).value === 'Yes')
    };
  }

  /* ENGRAVINGS note + _engraving_<id> attribute sync lives in engraving-notes.js
     (window.EngravingNotes), loaded globally so cart edits on any page stay in sync. */

  function openModal(modal) {
    modal.removeAttribute('hidden');
    document.body.classList.add('overflow-hidden');
    var firstInput = modal.querySelector('.engraving-input:not([hidden])');
    if (firstInput) firstInput.focus();
  }

  function closeModal(modal) {
    modal.setAttribute('hidden', '');
    document.body.classList.remove('overflow-hidden');
  }

  function getLogoFile(wrapper) {
    var inp = wrapper.querySelector('[data-engraving-logo-input]');
    if (!inp || !inp.files || !inp.files[0]) return null;
    return inp.files[0];
  }

  function formDataForAdd(id, qty, properties, cart) {
    var fd = new FormData();
    fd.append('id', id);
    fd.append('quantity', String(qty));
    if (properties) {
      Object.keys(properties).forEach(function (k) {
        var v = properties[k];
        if (v !== undefined && v !== null && v !== '') fd.append('properties[' + k + ']', v);
      });
    }
    if (cart && typeof cart.getSectionsToRender === 'function') {
      var sectionIds = cart.getSectionsToRender().map(function (s) { return s.id; });
      if (sectionIds.length) fd.append('sections', sectionIds.join(','));
      fd.append('sections_url', window.location.pathname);
    }
    return fd;
  }

  function formDataForAddMultipart(mainVariantId, qty, stringProps, filePropName, file, cart) {
    var fd = new FormData();
    fd.append('id', mainVariantId);
    fd.append('quantity', String(qty));
    if (stringProps) {
      Object.keys(stringProps).forEach(function (k) {
        var v = stringProps[k];
        if (v !== undefined && v !== null && v !== '') fd.append('properties[' + k + ']', v);
      });
    }
    if (file && filePropName) fd.append('properties[' + filePropName + ']', file, file.name);
    if (cart && typeof cart.getSectionsToRender === 'function') {
      var sectionIds = cart.getSectionsToRender().map(function (s) { return s.id; });
      if (sectionIds.length) fd.append('sections', sectionIds.join(','));
      fd.append('sections_url', window.location.pathname);
    }
    return fd;
  }

  /**
   * Shopify inventory / quantity-rule copy is terse. Map known strings for engraving fee adds.
   */
  function mapEngravingCartErrorMessage(raw, config) {
    var s = raw == null ? '' : String(raw);
    var lower = s.toLowerCase();
    var em = (config && config.errorMessages) || {};
    if (
      lower.indexOf('maximum quantity') !== -1 &&
      (lower.indexOf('already in your cart') !== -1 || lower.indexOf('in your cart') !== -1)
    ) {
      return em.inventory_max_in_cart || s;
    }
    if (lower.indexOf("you can't add more") !== -1 || lower.indexOf('cannot add more') !== -1) {
      return em.cant_add_more || s;
    }
    /* e.g. "Only 50 items were added to your cart due to availability." — Checkout add-to-cart limit, not stock */
    if (
      lower.indexOf('only ') !== -1 &&
      lower.indexOf('items were added') !== -1 &&
      (lower.indexOf('availability') !== -1 || lower.indexOf('due to') !== -1)
    ) {
      return em.partial_add_checkout_limit || s;
    }
    return s;
  }

  function formatShopifyCartError(parsed) {
    if (!parsed) return 'Cart request failed.';
    var d = parsed.description;
    if (Array.isArray(d)) {
      return d
        .map(function (x) {
          if (typeof x === 'string') return x;
          if (x && x.message) return x.message;
          return x ? String(x) : '';
        })
        .filter(Boolean)
        .join(' ');
    }
    if (d && typeof d === 'object') return JSON.stringify(d);
    if (d) return String(d);
    return parsed.message || 'Cart request failed.';
  }

  /**
   * Shopify /cart/add.js returns JSON for 200 and 4xx; theme dev may omit Content-Type.
   * Always parse JSON bodies so 422 description (e.g. quantity rules, inventory) surfaces.
   */
  function parseJsonResponse(res) {
    return res.text().then(function (text) {
      var trim = (text || '').trim();
      var parsed = null;
      if (trim.charAt(0) === '{' || trim.charAt(0) === '[') {
        try {
          parsed = JSON.parse(text);
        } catch (_) {}
      }
      if (!parsed) {
        if (!res.ok) {
          return Promise.reject(new Error(trim || 'Request failed (' + res.status + ').'));
        }
        return Promise.reject(new Error('Server returned an invalid response.'));
      }
      if (!res.ok && parsed.status && parsed.message) {
        return Promise.reject(new Error(formatShopifyCartError(parsed)));
      }
      return parsed;
    });
  }

  /**
   * Fee SKUs mirror the full design, not just the grouping id: apps that rewrite the
   * main product line (e.g. bundle discount apps) strip its properties, so the fee
   * lines are the durable copy that note/attribute rebuilds can recover from.
   * _engraving_parent_variant records which product variant this fee belongs to so
   * cascade removal can re-link to the main line after the bundle app strips its
   * _engraving_id (the fee line — a separate product — keeps its properties).
   */
  function feeLineProperties(payload, designProps, feeRole, parentVariantId) {
    var props = {
      _engraving_id: payload.engraving_id,
      _engraving_fee_line: feeRole,
      _engraving_parent_variant: parentVariantId ? String(parentVariantId) : '',
      Fee: feeRole
    };
    Object.keys(designProps || {}).forEach(function (k) {
      props[k] = designProps[k];
    });
    return props;
  }

  function doCartAdd(body) {
    var cartAddUrl = (window.routes && window.routes.cart_add_url) || '/cart/add';
    if (cartAddUrl.indexOf('.js') === -1) cartAddUrl = cartAddUrl + '.js';
    return fetch(cartAddUrl, {
      method: 'POST',
      body: body,
      headers: { 'X-Requested-With': 'XMLHttpRequest', 'Accept': 'application/json' }
    }).then(parseJsonResponse);
  }

  /**
   * Roll back a partially-added engraving (main line in, a fee add failed): remove
   * every cart line carrying this engraving id so the customer can retry cleanly
   * instead of checking out with an engraved item missing its fee.
   * Resolves true when lines were removed, false otherwise (best effort).
   */
  function removeEngravingLinesFromCart(engravingId) {
    var cartUrl = (window.routes && window.routes.cart_url) || '/cart';
    if (cartUrl.indexOf('.js') === -1) cartUrl += '.js';
    var changeUrl = (window.routes && window.routes.cart_change_url) || '/cart/change';
    if (changeUrl.indexOf('.js') === -1) changeUrl += '.js';
    return fetch(cartUrl)
      .then(function (r) { return r.json(); })
      .then(function (cartData) {
        var keys = (cartData.items || [])
          .filter(function (item) {
            return item.properties && item.properties._engraving_id === engravingId;
          })
          .map(function (item) { return item.key; });
        return keys
          .reduce(function (p, key) {
            return p.then(function () {
              return fetch(changeUrl, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest', 'Accept': 'application/json' },
                body: JSON.stringify({ id: key, quantity: 0 })
              });
            });
          }, Promise.resolve())
          .then(function () { return keys.length > 0; });
      })
      .catch(function () { return false; });
  }

  function initWrapper(wrapper) {
    if (wrapper.dataset.engravingBound === 'true') return;
    var sectionId = wrapper.dataset.engravingSection;
    var config = getConfig(sectionId);
    if (!config || !config.engravingTypes || !config.engravingTypes.length) return;

    var form = document.getElementById(config.productFormId);
    if (!form) return;
    wrapper.dataset.engravingBound = 'true';

    // Exactly what the customer last Applied — the single source of truth at submit
    // time. Live modal fields can drift after Apply (edits without re-applying, file
    // input cleared by a re-render); the cart must only ever receive this snapshot.
    var appliedState = null;
    // True when the browser blocked restoring the applied logo into the file input
    // on reopen — only then does an empty input mean "lost", not "removed".
    var logoRestoreFailed = false;

    var modal = wrapper.querySelector('.engraving-modal');
    var openBtn = wrapper.querySelector('[data-engraving-open]');
    var tk = getSelectedTypeKey(wrapper, config);
    var initialType = getTypeByKey(config, tk);
    applyTypeToUI(wrapper, config, initialType);

    wrapper.querySelectorAll('.engraving-type-option').forEach(function (btn) {
      btn.addEventListener('click', function () {
        wrapper.querySelectorAll('.engraving-type-option').forEach(function (b) {
          b.classList.remove('selected');
          b.setAttribute('aria-checked', 'false');
        });
        btn.classList.add('selected');
        btn.setAttribute('aria-checked', 'true');
        var key = btn.dataset.engravingTypeKey;
        var tc = getTypeByKey(config, key);
        applyTypeToUI(wrapper, config, tc);
      });
    });

    openBtn.addEventListener('click', function () {
      hideApplyError();
      openModal(modal);
      if (appliedState) {
        // Discard unapplied edits from a previous open — the modal always reopens
        // showing what will actually be added to the cart.
        restoreModalFromApplied();
      } else {
        var t = getTypeByKey(config, getSelectedTypeKey(wrapper, config));
        applyTypeToUI(wrapper, config, t);
      }
    });

    wrapper.addEventListener('change', function (e) {
      if (!e.target.matches('[data-engraving-side2-checkbox]')) return;
      var checked = e.target.checked;
      var sb = wrapper.querySelector('[data-engraving-side2-block]');
      var ps2 = wrapper.querySelector('[data-engraving-preview-side2]');
      if (sb) sb.hidden = !checked;
      if (ps2) ps2.hidden = !checked;
      if (!checked) {
        wrapper.querySelectorAll('[data-engraving-side2-line]').forEach(function (inp) { inp.value = ''; });
        var sid = wrapper.getAttribute('data-engraving-section');
        var cfg = getConfig(sid);
        var tk2 = getSelectedTypeKey(wrapper, cfg);
        var tc = getTypeByKey(cfg, tk2);
        if (tc) updatePreview(wrapper, tc);
      }
    });

    wrapper.querySelectorAll('[data-engraving-close], [data-engraving-cancel]').forEach(function (btn) {
      btn.addEventListener('click', function () { closeModal(modal); });
    });
    var overlay = wrapper.querySelector('.engraving-modal-overlay');
    if (overlay) overlay.addEventListener('click', function () { closeModal(modal); });

    function showApplyError(message) {
      var err = wrapper.querySelector('[data-engraving-error]');
      if (!err) return;
      if (!err.dataset.defaultText) err.dataset.defaultText = err.textContent.trim();
      err.textContent = message || err.dataset.defaultText;
      err.removeAttribute('hidden');
    }
    function hideApplyError() {
      var err = wrapper.querySelector('[data-engraving-error]');
      if (err) err.setAttribute('hidden', '');
    }

    /** Repopulate every modal field from appliedState (see Apply handler). */
    function restoreModalFromApplied() {
      if (!appliedState) return;
      wrapper.querySelectorAll('.engraving-type-option').forEach(function (b) {
        var sel = b.dataset.engravingTypeKey === appliedState.typeKey;
        b.classList.toggle('selected', sel);
        b.setAttribute('aria-checked', sel ? 'true' : 'false');
      });
      var tc = getTypeByKey(config, appliedState.typeKey);
      applyTypeToUI(wrapper, config, tc);

      appliedState.lines.forEach(function (v, i) {
        var inp = wrapper.querySelector('[data-engraving-line="' + (i + 1) + '"]');
        if (inp) inp.value = v || '';
      });

      var hasS2 = appliedState.side2.some(function (l) { return l; });
      var cb = wrapper.querySelector('[data-engraving-side2-checkbox]');
      if (cb) cb.checked = appliedState.side2Opted || hasS2;
      var showS2 = !!(cb && cb.checked);
      var sb = wrapper.querySelector('[data-engraving-side2-block]');
      if (sb) sb.hidden = !showS2;
      var ps2 = wrapper.querySelector('[data-engraving-preview-side2]');
      if (ps2) ps2.hidden = !showS2;
      appliedState.side2.forEach(function (v, i) {
        var inp = wrapper.querySelector('[data-engraving-side2-line="' + (i + 1) + '"]');
        if (inp) inp.value = v || '';
      });

      var fontBtns = wrapper.querySelectorAll('.engraving-font-option');
      var fontMatched = false;
      fontBtns.forEach(function (b) {
        var sel = b.dataset.fontValue === appliedState.font.value;
        if (sel) fontMatched = true;
        b.classList.toggle('selected', sel);
      });
      if (!fontMatched && fontBtns[0]) fontBtns[0].classList.add('selected');

      var waiver = wrapper.querySelector('[data-engraving-logo-waiver]');
      if (waiver) waiver.checked = !!appliedState.logoWaiver;

      // Put the applied logo back into the file input so the customer sees and can
      // change it. Where the browser blocks this, the Apply handler falls back to
      // appliedState.logoFile, so the logo is never silently dropped.
      var logoInput = wrapper.querySelector('[data-engraving-logo-input]');
      if (logoInput && appliedState.logoFile) {
        try {
          var dt = new DataTransfer();
          dt.items.add(appliedState.logoFile);
          logoInput.files = dt.files;
          logoRestoreFailed = false;
        } catch (_) {
          logoRestoreFailed = true;
        }
      }

      if (tc) {
        updateCharCountsForType(wrapper, tc);
        updatePreview(wrapper, tc);
      }
    }

    function bindInputs() {
      wrapper.querySelectorAll('.engraving-input').forEach(function (input) {
        input.addEventListener('input', function () {
          hideApplyError();
          var t = getTypeByKey(config, getSelectedTypeKey(wrapper, config));
          if (t) {
            updateCharCountsForType(wrapper, t);
            updatePreview(wrapper, t);
          }
        });
      });
      var logoInput = wrapper.querySelector('[data-engraving-logo-input]');
      if (logoInput) {
        logoInput.addEventListener('change', hideApplyError);
      }
    }
    bindInputs();

    function showConfirmation(lines, side2, fontLabel, typeTitle) {
      var confirmation = wrapper.querySelector('[data-engraving-confirmation]');
      var detailsEl = wrapper.querySelector('[data-engraving-confirmation-details]');
      if (!confirmation || !detailsEl) return;
      var parts = lines.filter(Boolean).map(function (text, i) { return 'Line ' + (i + 1) + ': ' + text; });
      var s2 = (side2 || []).filter(Boolean);
      if (s2.length) parts.push('Side 2: ' + s2.join(' | '));
      if (typeTitle) parts.push('Type: ' + typeTitle);
      if (fontLabel) parts.push('Font: ' + fontLabel);
      detailsEl.textContent = parts.join(' · ');
      confirmation.removeAttribute('hidden');
    }

    function hideConfirmation() {
      var confirmation = wrapper.querySelector('[data-engraving-confirmation]');
      var detailsEl = wrapper.querySelector('[data-engraving-confirmation-details]');
      if (confirmation) confirmation.setAttribute('hidden', '');
      if (detailsEl) detailsEl.textContent = '';
    }

    wrapper.querySelector('[data-engraving-apply]').addEventListener('click', function () {
      var typeKey = getSelectedTypeKey(wrapper, config);
      var typeConfig = getTypeByKey(config, typeKey);
      if (!typeConfig) return;
      var ml = Math.min(Math.max(typeConfig.maxLines || 3, 1), 3);
      var lines = getLines(wrapper, ml);
      var side2 = typeConfig.allowSecondSide ? getSide2Lines(wrapper, ml) : ['', '', ''];
      var hasText = lines.some(function (l) { return l.length > 0; });
      var hasSide2 = side2.some(function (l) { return l.length > 0; });
      var file = typeConfig.allowLogoUpload ? getLogoFile(wrapper) : null;
      // Browsers that block programmatic file-input restore leave the input empty
      // after a reopen — keep the previously applied logo rather than dropping it.
      // (When restore worked, an empty input means the customer removed the logo.)
      if (!file && typeConfig.allowLogoUpload && logoRestoreFailed && appliedState && appliedState.logoFile) {
        file = appliedState.logoFile;
      }
      var hasFile = !!file;
      if (!hasText && !hasSide2 && !hasFile) {
        showApplyError();
        return;
      }
      if (file && file.size > MAX_LOGO_BYTES) {
        showApplyError('Logo file is too large (max 20 MB). Please choose a smaller file.');
        return;
      }
      hideApplyError();
      var font = getSelectedFont(wrapper);
      var engravingId = Date.now().toString(36) + '-' + Math.random().toString(16).slice(2);
      var variantInput = form.querySelector('input[name="id"]');
      var variantId = variantInput ? variantInput.value : '';
      var waiverEl = wrapper.querySelector('[data-engraving-logo-waiver]');
      var logoWaiver = !!(waiverEl && waiverEl.checked);
      var side2cbApply = wrapper.querySelector('[data-engraving-side2-checkbox]');
      appliedState = {
        engravingId: engravingId,
        typeKey: typeKey,
        lines: lines.slice(),
        side2: side2.slice(),
        side2Opted: !!(side2cbApply && side2cbApply.checked && hasSide2),
        font: font,
        logoFile: file,
        logoWaiver: logoWaiver
      };
      setOrRemoveHiddenInputs(form, {
        engraving_enabled: true,
        engraving_id: engravingId,
        type_key: typeKey,
        font_label: font.label,
        lines: lines,
        side2_lines: side2,
        logo_waiver: logoWaiver,
        product_id: String(config.productId),
        variant_id: variantId,
        timestamp: Date.now()
      });
      var minApply = typeConfig.minQuantity || 1;
      if (minApply > 1 && getFormQuantity(form) < minApply) {
        setFormQuantity(form, minApply);
      }
      var pfeClear = form.closest('product-form');
      if (pfeClear && pfeClear.handleErrorMessage) pfeClear.handleErrorMessage();

      showConfirmation(lines, side2, font.label, typeConfig.title);
      closeModal(modal);
    });

    var productFormEl = form.closest('product-form');
    if (!productFormEl) return;

    // Capture on document, not the form: at the event target, listeners run in
    // registration order regardless of the capture flag, and product-form's submit
    // handler registers earlier — it would fire its own plain /cart/add before
    // stopImmediatePropagation() here could block it (double add, engraving dropped
    // from the duplicate). Document-level capture is guaranteed to run first.
    document.addEventListener('submit', function (evt) {
      if (evt.target !== form) return;
      var payload = getEngravingPayloadFromForm(form);
      if (!payload) return;

      evt.preventDefault();
      evt.stopImmediatePropagation();

      var typeKey = payload.type_key || config.defaultTypeKey;
      var typeConfig = getTypeByKey(config, typeKey);
      if (!typeConfig) return;

      var variantId = (form.querySelector('input[name="id"]') || {}).value;
      var quantity = getFormQuantity(form);
      var minQ = typeConfig.minQuantity || 1;
      if (quantity < minQ) {
        if (productFormEl.handleErrorMessage) {
          productFormEl.handleErrorMessage('Minimum quantity for this engraving is ' + minQ + '.');
        }
        return;
      }
      if (productFormEl.handleErrorMessage) productFormEl.handleErrorMessage();

      var submitBtn = productFormEl.querySelector('[type="submit"]');
      var cart = document.querySelector('cart-drawer');
      if (submitBtn) {
        submitBtn.setAttribute('disabled', 'true');
        submitBtn.classList.add('loading');
        var textEl = submitBtn.querySelector('[data-add-to-cart-text]');
        if (textEl) textEl.classList.add('hidden');
        var spinner = productFormEl.querySelector('.loading--spinner');
        if (spinner) spinner.classList.remove('hidden');
      }

      var ml = Math.min(Math.max(typeConfig.maxLines || 3, 1), 3);
      var lines = (payload.lines || []).slice(0, ml);
      var side2 = (payload.side2_lines || []).slice(0, ml);
      while (lines.length < 3) lines.push('');
      while (side2.length < 3) side2.push('');

      // Read from the applied snapshot, not live modal fields — they can have
      // drifted since Apply (edits without re-applying, cleared file input).
      var applied = appliedState && appliedState.engravingId === payload.engraving_id ? appliedState : null;
      var logoFile = applied ? applied.logoFile : getLogoFile(wrapper);
      var waiverEl = wrapper.querySelector('[data-engraving-logo-waiver]');
      var logoWaiverActive = !!(config.customerCanWaiveLogoFee &&
        (applied ? applied.logoWaiver : waiverEl && waiverEl.checked));
      var logoPropName = config.logoPropertyName || 'Logo';

      var designProps = {
        'Engraving type': typeConfig.title || typeKey,
        Font: payload.font_label
      };
      if (lines[0]) designProps['Line 1'] = lines[0];
      if (lines[1]) designProps['Line 2'] = lines[1];
      if (lines[2]) designProps['Line 3'] = lines[2];
      if (side2[0]) designProps['Side 2 line 1'] = side2[0];
      if (side2[1]) designProps['Side 2 line 2'] = side2[1];
      if (side2[2]) designProps['Side 2 line 3'] = side2[2];
      if (logoWaiverActive) designProps['Logo previously submitted'] = 'Yes';

      var stringPropsForMain = { _engraving_id: payload.engraving_id };
      Object.keys(designProps).forEach(function (k) {
        stringPropsForMain[k] = designProps[k];
      });

      var feeBaseProps = feeLineProperties(payload, designProps, 'Base engraving', variantId);
      var feeSideProps = feeLineProperties(payload, designProps, 'Second side', variantId);
      var feeLogoProps = feeLineProperties(payload, designProps, 'Logo setup', variantId);

      var vids = typeConfig.variantIds || {};
      var baseVid = vids.baseEngraving;
      var sideVid = vids.secondSide;
      var logoVid = vids.logoSetup;
      var hasSide2Text = side2.some(function (s) { return s && String(s).trim(); });
      var chargeLogoSetup = !!(logoFile && typeConfig.allowLogoUpload && logoVid) && !logoWaiverActive;

      // Flat-fee roles: these must always be qty=1 regardless of quantity rules on the
      // Shopify product. If /cart/add.js bumps the qty (e.g. product has min-qty rule),
      // correctFlatFeeQuantities() fetches the cart and forces them back to 1.
      var FLAT_FEE_ROLES = ['Base engraving', 'Logo setup'];

      function correctFlatFeeQuantities(addResponse) {
        var cartUrl = (window.routes && window.routes.cart_url) || '/cart';
        if (cartUrl.indexOf('.js') === -1) cartUrl += '.js';
        return fetch(cartUrl)
          .then(function (r) { return r.json(); })
          .then(function (cartData) {
            var corrections = [];
            var cartChangeUrl = (window.routes && window.routes.cart_change_url) || '/cart/change';
            if (cartChangeUrl.indexOf('.js') === -1) cartChangeUrl += '.js';
            (cartData.items || []).forEach(function (item) {
              var p = item.properties || {};
              if (
                p._engraving_id === payload.engraving_id &&
                FLAT_FEE_ROLES.indexOf(p._engraving_fee_line) !== -1 &&
                item.quantity !== 1
              ) {
                corrections.push(
                  fetch(cartChangeUrl, {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
                    // key-addressed: line indexes shift if the cart changes concurrently
                    body: JSON.stringify({ id: item.key, quantity: 1 })
                  })
                );
              }
            });
            return Promise.all(corrections).then(function () { return addResponse; });
          })
          .catch(function () { return addResponse; }); // non-critical — never block the main flow
      }

      // The logo file is uploaded on the main line, which a bundle app then strips —
      // taking the only copy of the logo with it. Mirror the uploaded file's URL onto
      // the durable fee lines (a string property, no re-upload). If the URL isn't in the
      // add response, re-upload the file itself to one fee line as a fallback so the
      // logo always survives somewhere a bundle app won't touch.
      function uploadedLogoUrl(resp) {
        if (!resp) return '';
        var item = resp.properties ? resp : (resp.items && resp.items[0]);
        return (item && item.properties && item.properties[logoPropName]) || '';
      }
      function withLogoUrl(props, url) {
        if (!url) return props;
        var o = {};
        Object.keys(props).forEach(function (k) { o[k] = props[k]; });
        o[logoPropName] = url;
        return o;
      }

      function chainAfterMain(addResponse) {
        var hasLogo = !!(logoFile && typeConfig.allowLogoUpload);
        var logoUrl = hasLogo ? uploadedLogoUrl(addResponse) : '';
        // Fallback: response carried no URL — re-upload the file to one fee line.
        var fileCarrier = (hasLogo && !logoUrl) ? (baseVid ? 'base' : (chargeLogoSetup ? 'logo' : null)) : null;

        var p = Promise.resolve(addResponse);
        if (baseVid) {
          p = p.then(function (prev) {
            var props = withLogoUrl(feeBaseProps, logoUrl);
            if (fileCarrier === 'base') {
              return doCartAdd(formDataForAddMultipart(String(baseVid), 1, props, logoPropName, logoFile, cart));
            }
            return doCartAdd(formDataForAdd(String(baseVid), 1, props, cart));
          });
        }
        // Side 2 fee follows the applied text, not the live checkbox — they can
        // disagree when the modal was reopened and closed without re-applying.
        var side2Opted = !!(sideVid && hasSide2Text);
        if (side2Opted) {
          p = p.then(function (prev) {
            return doCartAdd(formDataForAdd(String(sideVid), quantity, feeSideProps, cart));
          });
        }
        if (chargeLogoSetup) {
          p = p.then(function (prev) {
            var props = withLogoUrl(feeLogoProps, logoUrl);
            if (fileCarrier === 'logo') {
              return doCartAdd(formDataForAddMultipart(String(logoVid), 1, props, logoPropName, logoFile, cart));
            }
            return doCartAdd(formDataForAdd(String(logoVid), 1, props, cart));
          });
        }
        // After all fee adds, correct any flat-fee lines whose qty was bumped by Shopify rules
        p = p.then(function (lastResponse) {
          return correctFlatFeeQuantities(lastResponse);
        });
        return p;
      }

      // Adds are sequential, not transactional: if a fee add fails after the main
      // line landed, roll the whole engraving back so the cart never holds an
      // engraved item without its fee.
      var mainAdded = false;
      var addsComplete = false;

      var firstReq;
      if (logoFile && typeConfig.allowLogoUpload) {
        delete stringPropsForMain[logoPropName];
        firstReq = doCartAdd(formDataForAddMultipart(variantId, quantity, stringPropsForMain, logoPropName, logoFile, cart));
      } else {
        firstReq = doCartAdd(formDataForAdd(variantId, quantity, stringPropsForMain, cart));
      }

      firstReq
        .then(function (resp) {
          mainAdded = true;
          return resp;
        })
        .then(chainAfterMain)
        .then(function (addResponse) {
          if (addResponse.status && addResponse.message) {
            if (typeof publish === 'function' && window.PUB_SUB_EVENTS) {
              publish(window.PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: variantId,
                errors: addResponse.description,
                message: addResponse.message
              });
            }
            return Promise.reject(new Error(formatShopifyCartError(addResponse)));
          }
          addsComplete = true;
          return addResponse;
        })
        .then(function (addResponse) {
          // Resync the durable engraving records (ENGRAVINGS note section + _engraving_<id>
          // cart attributes) from fresh cart state so multi-item is correct and prior entries
          // reflect any quantity/title changes. Runs after correctFlatFeeQuantities, so cart
          // totals/HTML returned here are up-to-date.
          if (!window.EngravingNotes || typeof window.EngravingNotes.composeUpdate !== 'function') {
            return addResponse;
          }
          var cartGetUrl = (window.routes && window.routes.cart_url) || '/cart';
          if (cartGetUrl.indexOf('.js') === -1) cartGetUrl += '.js';
          var cartUpdateUrl = (window.routes && window.routes.cart_update_url) || '/cart/update';
          if (cartUpdateUrl.indexOf('.js') === -1) cartUpdateUrl += '.js';
          return fetch(cartGetUrl)
            .then(function (r) { return r.json(); })
            .then(function (cartData) {
              var updateBody = window.EngravingNotes.composeUpdate(cartData);
              if (!updateBody) return addResponse;
              if (cart && typeof cart.getSectionsToRender === 'function') {
                var sectionIds = cart.getSectionsToRender().map(function (s) { return s.id; });
                if (sectionIds.length) {
                  updateBody.sections = sectionIds;
                  updateBody.sections_url = window.location.pathname;
                }
              }
              return fetch(cartUpdateUrl, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest', 'Accept': 'application/json' },
                body: JSON.stringify(updateBody)
              }).then(function (res) {
                return parseJsonResponse(res).then(function (noteResp) {
                  return (noteResp && noteResp.sections) ? noteResp : addResponse;
                });
              });
            })
            .catch(function () { return addResponse; });
        })
        .then(function (addResponse) {
          // The design is in the cart now — clear the applied state so clicking
          // Add to cart again doesn't silently duplicate the engraving + fees.
          appliedState = null;
          setOrRemoveHiddenInputs(form, null);
          hideConfirmation();
          var logoInputEl = wrapper.querySelector('[data-engraving-logo-input]');
          if (logoInputEl) logoInputEl.value = '';

          if (cart && typeof cart.renderContents === 'function' && addResponse.sections) {
            cart.renderContents(addResponse);
            cart.classList.add('is-visible');
            document.body.classList.add('overflow-hidden');
          } else if (!cart) {
            window.location = window.routes.cart_url;
          }
          if (typeof publish === 'function' && window.PUB_SUB_EVENTS) {
            publish(window.PUB_SUB_EVENTS.cartUpdate, { source: 'product-form', productVariantId: variantId });
          }
        })
        .catch(function (err) {
          var raw =
            (err && err.message) || (err && err.description) || (typeof err === 'string' ? err : null);
          var needsRollback = mainAdded && !addsComplete;
          var rollback = needsRollback
            ? removeEngravingLinesFromCart(payload.engraving_id)
            : Promise.resolve(false);
          return rollback.then(function (rolledBack) {
            if (rolledBack && window.EngravingNotes && typeof window.EngravingNotes.rebuildFromCart === 'function') {
              window.EngravingNotes.rebuildFromCart();
            }
            if (!productFormEl.handleErrorMessage) return;
            var cfg = getConfig(sectionId);
            var msg = raw ? mapEngravingCartErrorMessage(raw, cfg) : null;
            if (msg && rolledBack) msg += ' Your cart has not been changed — please try again.';
            if (msg) productFormEl.handleErrorMessage(msg);
          });
        })
        .finally(function () {
          if (submitBtn) {
            submitBtn.classList.remove('loading');
            submitBtn.removeAttribute('disabled');
            var te = productFormEl.querySelector('[data-add-to-cart-text]');
            if (te) te.classList.remove('hidden');
            var sp = productFormEl.querySelector('.loading--spinner');
            if (sp) sp.classList.add('hidden');
          }
        });
    }, true);
  }

  function init() {
    document.querySelectorAll('.engraving-wrapper').forEach(initWrapper);
  }

  /* Quick view injects product content (engraving wrapper, config JSON, and form
     together) after load — bind wrappers as they appear. initWrapper is idempotent
     via data-engraving-bound, so re-scanning is safe. */
  function watchForInjectedWrappers() {
    if (typeof MutationObserver !== 'function') return;
    new MutationObserver(function (mutations) {
      for (var i = 0; i < mutations.length; i++) {
        var added = mutations[i].addedNodes;
        for (var j = 0; j < added.length; j++) {
          var node = added[j];
          if (node.nodeType !== 1) continue;
          if (node.classList && node.classList.contains('engraving-wrapper')) {
            initWrapper(node);
          } else if (node.querySelectorAll) {
            node.querySelectorAll('.engraving-wrapper').forEach(initWrapper);
          }
        }
      }
    }).observe(document.documentElement, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      init();
      watchForInjectedWrappers();
    });
  } else {
    init();
    watchForInjectedWrappers();
  }
})();
